var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2572 4.07751C15.2572 4.07751 15.2572 0.5 11.9778 0.5C8.69845 0.5 8.69845 4.07751 8.69845 4.07751M11.9778 14.81C17.4082 14.81 21.7145 12.3576 23.0356 11.5138C23.3052 11.3415 23.4557 11.0432 23.4557 10.7233V5.07751C23.4557 4.52522 23.008 4.07751 22.4557 4.07751H1.5C0.947715 4.07751 0.5 4.52522 0.5 5.07751V10.7233C0.5 11.0432 0.650488 11.3415 0.920111 11.5138C2.24115 12.3576 6.54748 14.81 11.9778 14.81ZM11.9778 16.5988V13.0213V16.5988ZM1.31985 13.1269V20.965C1.31985 21.5173 1.76756 21.965 2.31984 21.965H21.6358C22.1881 21.965 22.6358 21.5173 22.6358 20.965V13.1269C22.6358 12.5746 22.1881 12.1269 21.6358 12.1269H2.31985C1.76756 12.1269 1.31985 12.5746 1.31985 13.1269Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.e2ec01304b8b6a6c9ddd7d04f581002e.svg";
export { ForwardRef as ReactComponent };